export default {
  ITEM_UNAVAILABLE: 'Item unavailable',
  MISSING_SPECS: 'Missing specs',
  ORDER_ADJUSTMENT: 'Order adjustment',
  CANCELLATION: 'Cancellation',
  RETURN: 'Return',
  EXCHANGE: 'Exchange',
  MISSING_ITEM: 'Missing item',
  TRACKING_INQUIRY: 'Tracking inquiry',
  ORDER_INFORMATION: 'Order information',
  OTHER: 'Other'
} as { [key: string]: string }
